export type FeatureCategory =
  | "visual"
  | "reading"
  | "navigation"
  | "simplification";

export type FeaturePanelDefinition = {
  category: FeatureCategory;
  key: string;
  label: string;
};

export const featureCategoryOrder: FeatureCategory[] = [
  "visual",
  "reading",
  "navigation",
  "simplification",
];

export const featureCategoryLabels: Record<FeatureCategory, string> = {
  visual: "Görsel Ayarlar",
  reading: "Okuma Desteği",
  navigation: "Navigasyon ve Vurgu",
  simplification: "Sayfa Sadeleştirme",
};

export const featurePanelRegistry: FeaturePanelDefinition[] = [
  { key: "text-size", label: "Yazı boyutu", category: "visual" },
  { key: "contrast-mode", label: "Kontrast modu", category: "visual" },
  { key: "blue-filter", label: "Mavi filtre", category: "visual" },
  { key: "grayscale", label: "Gri ton", category: "visual" },
  { key: "font-family", label: "Yazı tipi", category: "visual" },
  { key: "reading-mode", label: "Okuma modu", category: "reading" },
  { key: "line-spacing", label: "Satır aralığı", category: "reading" },
  { key: "letter-spacing", label: "Harf aralığı", category: "reading" },
  { key: "reading-guide", label: "Okuma cetveli", category: "reading" },
  {
    key: "highlight-links",
    label: "Bağlantıları vurgula",
    category: "navigation",
  },
  {
    key: "highlight-headings",
    label: "Başlıkları vurgula",
    category: "navigation",
  },
  { key: "focus-emphasis", label: "Odak vurgusu", category: "navigation" },
  { key: "large-cursor", label: "Büyük imleç", category: "navigation" },
  {
    key: "hide-images",
    label: "Görselleri gizle",
    category: "simplification",
  },
  {
    key: "pause-animations",
    label: "Animasyonları duraklat",
    category: "simplification",
  },
];

const registryByKey = new Map(
  featurePanelRegistry.map((definition) => [definition.key, definition]),
);

export function getFeaturePanelDefinition(key: string) {
  return registryByKey.get(key);
}
